import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { MediaStreamType as MEDIA_STREAM_TYPES, MediaStreamDeliveryPriority as MEDIA_STREAM_DELIVERY_PRIORITY } from 'playable/dist/src/constants';
import { pick } from 'lodash';
import { convertSToMS } from '../../../utils/time';
const INTERVAL_TIME = 5000;
const DEFAULT_VALUES_FOR_VIDEO = {
  bitrate: 0,
  width: 0,
  height: 0
};
export default class StatisticLogger extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "sendBI", () => {
      const {
        videoID,
        engine,
        isEmbed,
        isLive,
        channelID,
        logFunction
      } = this.props;
      const debugInfo = engine.getDebugInfo();
      const {
        url,
        type,
        width,
        height,
        viewportWidth,
        viewportHeight,
        bitrate,
        deliveryPriority,
        currentTime,
        duration
      } = this.getDataForBI(debugInfo);
      logFunction({
        videoID,
        channelID,
        isEmbed,
        isLive,
        videoUrl: url,
        videoType: type,
        deliveryType: MEDIA_STREAM_DELIVERY_PRIORITY[deliveryPriority],
        bitrate,
        videoWidth: width,
        videoHeight: height,
        viewportWidth,
        viewportHeight,
        timeFrame: currentTime,
        duration: convertSToMS(duration)
      });
    });
    if (props.videoID && props.shouldSendBI) {
      this.startIntervalBILogging();
    }
  }
  UNSAFE_componentWillReceiveProps(newProps) {
    const {
      shouldSendBI,
      videoID
    } = newProps;
    if (shouldSendBI) {
      if (videoID) {
        if (videoID !== this.props.videoID) {
          this.stopIntervalBILogging();
          this.startIntervalBILogging();
        } else if (this.props.shouldSendBI !== shouldSendBI) {
          this.startIntervalBILogging();
        }
      }
    } else if (this.props.shouldSendBI !== shouldSendBI) {
      this.stopIntervalBILogging();
    }
  }
  componentWillUnmount() {
    this.stopIntervalBILogging();
  }
  startIntervalBILogging() {
    this._loggingInterval = setInterval(this.sendBI, INTERVAL_TIME);
  }
  getDataForBI(info) {
    const {
      url,
      currentTime,
      type,
      deliveryPriority,
      viewDimensions: {
        width: viewportWidth,
        height: viewportHeight
      },
      duration
    } = info;
    const baseInfo = {
      url,
      type,
      deliveryPriority,
      currentTime,
      viewportWidth,
      viewportHeight,
      duration
    };
    let transformedInfo = null;
    switch (type) {
      case MEDIA_STREAM_TYPES.DASH:
        {
          transformedInfo = {
            ...baseInfo,
            ...DEFAULT_VALUES_FOR_VIDEO,
            ...this.getDashInfo(info)
          };
          break;
        }
      case MEDIA_STREAM_TYPES.HLS:
        {
          transformedInfo = {
            ...baseInfo,
            ...DEFAULT_VALUES_FOR_VIDEO,
            ...this.getHlsInfo(info)
          };
          break;
        }
      default:
        {
          transformedInfo = {
            ...baseInfo,
            ...DEFAULT_VALUES_FOR_VIDEO
          };
          break;
        }
    }
    return transformedInfo;
  }
  getStreamInfo(info) {
    return pick(info.currentBitrate, ['width', 'height', 'bitrate']);
  }
  getDashInfo(info) {
    return this.getStreamInfo(info);
  }
  getHlsInfo(info) {
    const {
      currentBitrate
    } = info;
    if (currentBitrate) {
      return this.getStreamInfo(info);
    }
    return {
      ...DEFAULT_VALUES_FOR_VIDEO
    };
  }
  stopIntervalBILogging() {
    clearInterval(this._loggingInterval);
  }
  render() {
    return null;
  }
}
_defineProperty(StatisticLogger, "dependencies", ['engine']);
_defineProperty(StatisticLogger, "defaultProps", {
  isEmbed: false,
  duration: null
});
//# sourceMappingURL=statistic-logger.js.map